import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { LayoutComponent } from 'app/layout/layout.component';
import { AuthGuard } from 'app/modules/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/modules/auth/guards/noAuth.guard';

export const appRoutes: Route[] = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'sign-in',
    },

    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'crm-connect',
    },

    {
        path: '',
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'landing',
                loadChildren: () =>
                    import('app/modules/landing/landing.routes'),
            },
        ],
    },

    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            { path: '', loadChildren: () => import('@auth/auth.routes') },
        ],
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/pages/sign-out/sign-out.routes'),
            },
        ],
    },

    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'global-config',
                loadChildren: () =>
                    import('@globalConfig/global-config.routes'),
            },
            {
                path: 'crm-connect',
                loadChildren: () => import('@crmConnect/crm-connect.routes'),
            },
            {
                path: 'cms',
                loadChildren: () => import('@cms/cms.routes'),
            },
            {
                path: 'career-portal',
                loadChildren: () =>
                    import('@careerPortal/career-portal.routes'),
            },
            {
                path: 'errors',
                loadChildren: () => import('@errors/error.routes'),
            },
            { path: '**', redirectTo: 'errors/error-404' },
        ],
    },
];
